import React from "react";
import {FormControlLabel, Radio, Typography} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";
import {FontFamily} from "../../../constants";

type FontOptionsProps = {
  fonts: {name: FontFamily; fontFamily: string}[];
  selectedFont: string;
  handleFontChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  signatureText: string;
  fontsMap: Record<FontFamily, string>;
};

const FontOptions: React.FC<FontOptionsProps> = ({
  fonts,
  selectedFont,
  handleFontChange,
  signatureText,
  fontsMap,
}) => {
  const classes = useStyles();

  return (
    <>
      {fonts.map((font) => (
        <FormControlLabel
          key={font.name}
          value={font.fontFamily}
          control={
            <Radio
              checked={selectedFont === font.fontFamily}
              onChange={handleFontChange}
              classes={{
                root: classes.radio,
                checked: classes.radio,
              }}
            />
          }
          label={
            <Typography className={clsx(classes.fontText, fontsMap[font.name])}>
              {signatureText}
            </Typography>
          }
        />
      ))}
    </>
  );
};

export default FontOptions;
